// extracted by mini-css-extract-plugin
module.exports = {"flash":"FlashMessage_flash__86v8h","success":"FlashMessage_success__2A_m8","warning":"FlashMessage_warning__Oa_-k","error":"FlashMessage_error__CP-Gr"};